import { Controller } from "@hotwired/stimulus"

// Toggles visibility of a content element when the trigger is clicked.
export default class extends Controller {
  static targets = ["trigger", "content"]

  toggle() {
    if (!this.hasContentTarget) return
    this.contentTarget.classList.toggle("hidden")
  }
}
